<template>
    <div class="h-full w-full z-100 bg-white fixed top-0 left-0 right-0 bottom-0 z-200 flex flex-col overflow-auto">
        <template v-if="!qrStatus">
            <div class="flex items-center my-5 px30">
                <button type="button" class="btn-empty-wrapper mr-5" @click="closeQrReader">
                    <Close icon="back"></Close>
                </button>
                <span>{{ partnerName }}</span>
            </div>
            <div class="flex-grow flex justify-center items-center relative">
                <div class="decode-result" v-if="result">
                    {{ $t("Wait...") }}
                </div>
                <qrcode-stream v-if="!result" :camera="camera" @decode="onDecode" @init="onInit">
                    <div class="scan-confirmation">
                        <img src="data:image/svg+xml;base64,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"
                            width="240px" class="block mx-auto" alt="Search..." />
                    </div>
                </qrcode-stream>
                <img v-if="!$getState('corporation')['is']" class="page-logo-qr block absolute" :srcset="
                    `${$store.state.appUrl}/img/pwa/login/login-logo@2x.png, ${$store.state.appUrl}/img/pwa/login/login-logo@2x.png`
                " :src="`${$store.state.appUrl}/img/pwa/login/login-logo@2x.png`" alt="Thrive" width="245px"
                    height="56px" />
                <img v-else class="page-logo-qr block absolute" :srcset="$getState('corporation')['white_logo']"
                    :src="$getState('corporation')['white_logo']" alt="Thrive" width="245px" height="56px" />
            </div>
        </template>
        <div v-else class="flex flex-grow flex-col">
            <template v-if="verifyStatus">
                <div class="congratulations">
                    <div class='congratulations-page-img'>
                        <img v-if="!$getState('corporation')['is']" :srcset="
                            `${$store.state.appUrl}/img/pwa/congratulations/thanku-1.png, ${$store.state.appUrl}/img/pwa/congratulations/thanku-1@2x.png`
                        " :src="
    `${$store.state.appUrl}/img/pwa/congratulations/thanku-1.png`
" alt="Thrive Congratulations" />
                        <div v-else class="qr-bg-color"></div>
                        <div class='congratulations-msg'>
                            <div class='congratulations-msg-1'>
                                <div class="success-checkmark relative">
                                    <img class='congratulations-msg-img absolute' :srcset="
                                        `${$store.state.appUrl}/img/pwa/congratulations/checkmark.svg, ${$store.state.appUrl}/img/pwa/congratulations/checkmark.svg`
                                    " :src="
    `${$store.state.appUrl}/img/pwa/congratulations/checkmark.svg`
" alt="Thrive Congratulations" />
                                </div>
                                <h2>
                                    <span class='text-primary font-bold'>{{ $t("Congratulations") }}</span>
                                    <span class='congratulations-txt-1 font-bold'>
                                        {{ $t("Your verification is successful!")
                                        }}</span>
                                </h2>
                                <p class="text-center text-14 my-5">
                                    Make sure you are using one of the cards on file to roundup your change for this
                                    transaction!
                                </p>
                                <img class='congratulations-msg-img' :srcset="
                                    `${$store.state.appUrl}/img/pwa/congratulations/Back.svg, ${$store.state.appUrl}/img/pwa/congratulations/Back.svg`
                                " :src="
    `${$store.state.appUrl}/img/pwa/congratulations/Back.svg`
" alt="Thrive Congratulations" />
                            </div>
                            <div class="bank-card-list">
                                <swiper ref="mySwiper" :options="swiperOptions">
                                    <swiper-slide v-for="(card, index) in cards" :key="index">
                                        <CardItem :card="card" :index="index" :edit="false" @actionWithCard="false"
                                            :clickHandler="back" type="stripe" />
                                    </swiper-slide>
                                </swiper>
                            </div>

                            <div class="great-deal-score">
                                <h3 class="text-20 font-bold">Looks like you scored a great deal.</h3>
                                <p class="text-14">Would you like to donate some of your savings to your charity? Every
                                    dollar can make a huge impact.</p>
                            </div>

                            <div class="give-extra-section">
                                <Extra />
                            </div>
                            <button class='btn congratulations-btn' v-ripple @click="dashboardRedirect">
                                <img :src="`${$store.state.appUrl}/img/pwa/congratulations/thanku-2.svg`" />
                                <span>{{ $t("Go to Dashboard") }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="error">
                    <div v-if="connectionStatus">
                        <div class='error-page-img'>
                            <img v-if="!$getState('corporation')['is']" :srcset="
                                `${$store.state.appUrl}/img/pwa/error/background.svg, ${$store.state.appUrl}/img/pwa/error/background@svg.png`
                            " :src="
    `${$store.state.appUrl}/img/pwa/error/background.svg`
" alt="Thrive Congratulations" />
                            <div v-else class="qr-bg-color"></div>
                            <div class='error-msg'>
                                <div class='error-msg-1'>
                                    <img class='error-dog-img' :srcset="
                                        `${$store.state.appUrl}/img/pwa/error/dog.svg, ${$store.state.appUrl}/img/pwa/error/dog.svg`
                                    " :src="
    `${$store.state.appUrl}/img/pwa/error/dog.svg`
" alt="Thrive Congratulations" />
                                    <img class='error-cross-img' :srcset="
                                        `${$store.state.appUrl}/img/pwa/error/x-button.svg, ${$store.state.appUrl}/img/pwa/error/x-button.svg`
                                    " :src="
    `${$store.state.appUrl}/img/pwa/error/x-button.svg`
" alt="Thrive Congratulations" />
                                    <div class="error-text">
                                        <h3 class="error-txt-1 text-primary">
                                            {{ $t("Sorry...") }}
                                        </h3>
                                        <h3 class='error-txt-1'>
                                            {{ $t("Your verification failed") }}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Button type="button" :click-handler="checkAgain" :text="$t('Try again')"
                            classes="w-full btn-tryagain py-6" />
                    </div>
                    <div v-else>
                        <div class='error-page-img'>
                            <img v-if="!$getState('corporation')['is']" :srcset="
                                `${$store.state.appUrl}/img/pwa/error/background.svg, ${$store.state.appUrl}/img/pwa/error/background@svg.png`
                            " :src="
    `${$store.state.appUrl}/img/pwa/error/background.svg`
" alt="Thrive Congratulations" />
                            <div v-else class="qr-bg-color"></div>
                            <div class='error-msg'>
                                <div class='error-msg-1'>
                                    <img class='error-cat-img' :srcset="
                                        `${$store.state.appUrl}/img/pwa/error/cat.svg, ${$store.state.appUrl}/img/pwa/error/cat.svg`
                                    " :src="
    `${$store.state.appUrl}/img/pwa/error/cat.svg`
" alt="Thrive Congratulations" />
                                    <img class='error-cross-img' :srcset="
                                        `${$store.state.appUrl}/img/pwa/error/x-button.svg, ${$store.state.appUrl}/img/pwa/error/x-button.svg`
                                    " :src="
    `${$store.state.appUrl}/img/pwa/error/x-button.svg`
" alt="Thrive Congratulations" />
                                    <div class="error-text">
                                        <h3 class="error-txt-1 text-primary">
                                            {{ $t("Sorry...") }}
                                        </h3>
                                        <h3 class='error-txt-1'>
                                            {{ $t("Connection error...") }}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Button type="button" :click-handler="checkAgain" :text="$t('Try again')"
                            classes="w-full btn-tryagain py-6" />
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import Close from "../UI/Close";
import UserAvatar from "../Icons/UserAvatar";
import Button from "../UI/Button";
import VerificationCheckIcon from "../Icons/VerificationCheckIcon";
import ConnectionErrorIcon from "../Icons/ConnectionErrorIcon";
import VerificationFailedIcon from "../Icons/VerificationFailedIcon";
import Extra from "../Giving/Extra_new.vue";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import CardItem from '../../components/Settings/CardItem.vue';
import Vue from "vue";

export default {
    name: "QrCodeReader",

    components: {
        VerificationFailedIcon,
        ConnectionErrorIcon,
        VerificationCheckIcon,
        Button,
        UserAvatar,
        Close,
        QrcodeStream,
        Extra,
        Swiper,
        SwiperSlide,
        CardItem
    },

    props: ["partnerName", "partnerId"],

    data: function () {
        return {
            camera: "auto",
            cards: {},
            result: null,
            showScanConfirmation: false,
            verifyStatus: true,
            qrStatus: false,
            connectionStatus: true,
            error: "",
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination'
                },
                spaceBetween: 20,
                slidesPerView: 1.1,
            },
        };
    },

    mounted() {
        this.getListCards();
    },

    methods: {
        closeQrReader: function () {
            this.$emit("closeQrReader");
        },

        async onInit(promise) {
            try {
                await promise;
            } catch (error) {
                console.error(error);
                if (error.name === "NotAllowedError") {
                    this.error =
                        "ERROR: you need to grant camera access permission";
                } else if (error.name === "NotFoundError") {
                    this.error = "ERROR: no camera on this device";
                } else if (error.name === "NotSupportedError") {
                    this.error =
                        "ERROR: secure context required (HTTPS, localhost)";
                } else if (error.name === "NotReadableError") {
                    this.error = "ERROR: is the camera already in use?";
                } else if (error.name === "OverconstrainedError") {
                    this.error = "ERROR: installed cameras are not suitable";
                } else if (error.name === "StreamApiNotSupportedError") {
                    this.error =
                        "ERROR: Stream API is not supported in this browser";
                } else if (error.name === "InsecureContextError") {
                    this.error =
                        "ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.";
                } else {
                    this.error = `ERROR: Camera error (${error.name})`;
                }
                this.$toastr.e(this.$t(this.error));
                this.closeQrReader();
            } finally {
                this.showScanConfirmation = this.camera === "off";
            }
        },

        async onDecode(content) {
            this.result = content;
            if (navigator && navigator.onLine !== undefined) {
                if (!navigator.onLine) {
                    this.connectionStatus = false;
                    this.verifyStatus = false;
                    this.result = "";
                    this.qrStatus = true;
                } else {
                    this.verifyStatus = true;
                    this.connectionStatus = true;
                    this.qrStatus = false;
                    this.result = content;
                }
            }

            if (this.result) {
                this.qrVerify();
            }

            this.pause();
            await this.timeout(500);
            this.unpause();
        },

        qrVerify: function () {
            if (navigator && navigator.onLine !== undefined) {
                if (!navigator.onLine) {
                    this.connectionStatus = false;
                    this.verifyStatus = false;
                    return false;
                }
            }

            this.$http
                .post("retailer/scanqr", {
                    qr_code: this.result,
                    partner_id: this.partnerId
                })
                .then(res => {
                    this.connectionStatus = true;
                    if (res && res.status !== undefined && res.status) {
                        this.qrStatus = true;
                        this.verifyStatus = true;
                    } else {
                        this.qrStatus = true;
                        this.verifyStatus = false;
                    }
                })
                .catch(e => {
                    console.log(e);
                    this.qrStatus = true;
                    this.connectionStatus = false;
                    this.verifyStatus = false;
                });
        },

        unpause() {
            this.camera = "auto";
        },

        pause() {
            this.camera = "off";
        },

        timeout(ms) {
            return new Promise(resolve => {
                window.setTimeout(resolve, ms);
            });
        },

        checkAgain: function () {
            this.result = null;
            this.showScanConfirmation = false;
            this.verifyStatus = true;
            this.qrStatus = false;
            this.connectionStatus = true;
        },

        clickHandler: function () {
            this.$router.push("/dashboard");
        },

        getListCards: function () {
            this.cards = {};
            this.$http.get('user/listcard').then((res) => {
                if (res && res.status !== undefined && res.status) {
                    this.cards = !!res.data.card_data ? res.data.card_data : {};
                    if (this.$isEmptyObj(this.cards)) {
                        this.$toastr.e(this.$t('Donations will be stopped'));
                    }
                }

                if (res && res.status !== undefined && !res.status) {
                    this.processHandler = 'addCard';
                }
            });
        },
        back: function (value) {
            this.processHandler = '';
            this.card = [];
            this.cardIndex = '';
            if (value === 'authorize' || value === 'addAnotherCard') {
                this.getListCards();
            }
        },
        dashboardRedirect: function () {
            this.$router.push("/dashboard");
        },
    }
};
</script>
